// This file is auto-generated by scripts/regen-bestiary.mjs. Do not edit manually.

import { ISpritesheetData } from 'pixi.js';

export interface ISpritesheetMetadata {
  name: string;
  metadata: ISpritesheetData;
}

export const CellSpritesheets: ISpritesheetMetadata[] = [
  {
    name: 'cell-idle',
    metadata: {
      frames: {
        'cell-idle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-idle-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-idle-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/cell/idle.png',
        size: {
          w: 192,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'cell-idle': ['cell-idle-0', 'cell-idle-1', 'cell-idle-2'],
      },
    },
  },
  {
    name: 'cell-run',
    metadata: {
      frames: {
        'cell-run-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-run-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-run-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-run-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-run-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/cell/run.png',
        size: {
          w: 320,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'cell-run': [
          'cell-run-0',
          'cell-run-1',
          'cell-run-2',
          'cell-run-3',
          'cell-run-4',
        ],
      },
    },
  },
  {
    name: 'cell-windIdle',
    metadata: {
      frames: {
        'cell-windIdle-0': {
          frame: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-windIdle-1': {
          frame: {
            x: 64,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-windIdle-2': {
          frame: {
            x: 128,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-windIdle-3': {
          frame: {
            x: 192,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-windIdle-4': {
          frame: {
            x: 256,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-windIdle-5': {
          frame: {
            x: 320,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
        'cell-windIdle-6': {
          frame: {
            x: 384,
            y: 0,
            w: 64,
            h: 64,
          },
          sourceSize: {
            w: 64,
            h: 64,
          },
          spriteSourceSize: {
            x: 0,
            y: 0,
            w: 64,
            h: 64,
          },
        },
      },
      meta: {
        image: '/sprites/entities/cell/windIdle.png',
        size: {
          w: 448,
          h: 64,
        },
        scale: '1',
      },
      animations: {
        'cell-windIdle': [
          'cell-windIdle-0',
          'cell-windIdle-1',
          'cell-windIdle-2',
          'cell-windIdle-3',
          'cell-windIdle-4',
          'cell-windIdle-5',
          'cell-windIdle-6',
        ],
      },
    },
  },
];
